import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { Buffer } from 'buffer';


@Component({
  selector: 'app-receiptsettings',
  templateUrl: './receiptsettings.component.html',
  styleUrls: ['./receiptsettings.component.css']
})
export class ReceiptsettingsComponent implements OnInit, AfterViewInit, OnDestroy {


  settingsColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  saveloading: boolean;
  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "ReceiptSettings";


  receiptsettingsform = new FormGroup({
    restaurantname: new FormControl(null),
    address1: new FormControl(null),
    address2: new FormControl(null),
    address3: new FormControl(null),
    address4: new FormControl(null),
    address5: new FormControl(null),
    header1: new FormControl(null),
    header2: new FormControl(null),
    header3: new FormControl(null),
    header4: new FormControl(null),
    header5: new FormControl(null),
    receipttitle: new FormControl(null),
    footer1: new FormControl(null),
    footer2: new FormControl(null),
    footer3: new FormControl(null),
    footer4: new FormControl(null),
    footer5: new FormControl(null),
    font: new FormControl(null),
    fontsize: new FormControl(null),
    receiptimg: new FormControl(null),
    enablegstno: new FormControl(false),
    enablefssaino: new FormControl(false),
    restaurantnamelan: new FormControl(null),
    address1lan: new FormControl(null),
    address2lan: new FormControl(null),
    address3lan: new FormControl(null),
    address4lan: new FormControl(null),
    address5lan: new FormControl(null),
    inactive: new FormControl(false),
  });


  //set image
  image;
  strImage: any;
  picurl:any="";
  picname: string = "";

  printtype:any=""

  constructor(private appService: DhukanDataService, private sanitizer: DomSanitizer, public router: Router,private http: HttpClient,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private productFindService: NgbModal, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isedit) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }


  ngOnInit() {
    try {

      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isedit) {
          this.fnOnInitForm();

          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {

    this.receiptsettingsform.reset();
    this.fnInitializeForm();

    this.fngetReceiptSettings();
  
    this.printtype=this.loginService.fnCheckCompanysettings("PRINT_LANGUAGE")
    
  }

  fnCheckPrivilage() {
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  fnInitializeForm() {
    this.receiptsettingsform.setValue({
      restaurantname: null,
      address1: null,
      address2: null,
      address3: null,
      address4: null,
      address5: null,
      header1: null,
      header2: null,
      header3: null,
      header4: null,
      header5: null,
      receipttitle: null,
      footer1: null,
      footer2: null,
      footer3: null,
      footer4: null,
      footer5: null,
      font: null,
      fontsize: null,
      receiptimg: null,
      enablegstno: false,
      enablefssaino: false,
      restaurantnamelan: null,
      address1lan: null,
      address2lan: null,
      address3lan: null,
      address4lan: null,
      address5lan: null,
      inactive: false,
    });
  }

  fngetReceiptSettings() {
    var data = {
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getReceiptSettings(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.settingsColl = res.json().result;

            if (this.settingsColl.length > 0) {
              var editdata = this.settingsColl[0];
              this.fnEditMode(editdata);
            }
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })


  }


  fnSaveBtnClick() {

    if (this.saveloading) {
      return
    }

    var image_binary = this.picurl.replace(/^data:image\/\w+;base64,/, "");

    this.saveloading = true;
    var data = {
      'restaurantname': this.receiptsettingsform.get('restaurantname').value,
      'address1': this.receiptsettingsform.get('address1').value,
      'address2': this.receiptsettingsform.get('address2').value,
      'address3': this.receiptsettingsform.get('address3').value,
      'address4': this.receiptsettingsform.get('address4').value,
      'address5': this.receiptsettingsform.get('address5').value,
      'header1': this.receiptsettingsform.get('header1').value,
      'header2': this.receiptsettingsform.get('header2').value,
      'header3': this.receiptsettingsform.get('header3').value,
      'header4': this.receiptsettingsform.get('header4').value,
      'header5': this.receiptsettingsform.get('header5').value,
      'receipttitle': this.receiptsettingsform.get('receipttitle').value,
      'footer1': this.receiptsettingsform.get('footer1').value,
      'footer2': this.receiptsettingsform.get('footer2').value,
      'footer3': this.receiptsettingsform.get('footer3').value,
      'footer4': this.receiptsettingsform.get('footer4').value,
      'footer5': this.receiptsettingsform.get('footer5').value,
      'font': this.receiptsettingsform.get('font').value,
      'fontsize': this.receiptsettingsform.get('fontsize').value,
      'receiptimg': null, //image_binary,
      'enablegstno': this.receiptsettingsform.get('enablegstno').value,
      'enablefssaino': this.receiptsettingsform.get('enablefssaino').value,
      'picurl':  this.strImage,
      'restaurantnamelan': this.receiptsettingsform.get('restaurantnamelan').value,
      'address1lan': this.receiptsettingsform.get('address1lan').value,
      'address2lan': this.receiptsettingsform.get('address2lan').value,
      'address3lan': this.receiptsettingsform.get('address3lan').value,
      'address4lan': this.receiptsettingsform.get('address4lan').value,
      'address5lan': this.receiptsettingsform.get('address5lan').value,   
      'inactive': this.receiptsettingsform.get('inactive').value,
      'companyid': this.loginService.fnGetCompanyId(),
      'createdby': this.loginService.fnGetModUserId(),
      'modifiedby': this.loginService.fnGetModUserId(),
    }

    this.appService.fnSetReceiptSettings(data).subscribe(
      (res) => {
        this.saveloading = false
        if (res.json().status === 200) {
          this.toastr.success('', "The settings has been updated successfully.");
          this.fnCloseForm();
        }
        else{
          this.fnShowErrorMsg(res.json().err_field);
          
        }
      },
      (err) => {
        this.saveloading = false
        this.toastr.error('Error', err);
      });


  }


  fnCloseForm() {
    try {
      this.router.navigate(['/Configration']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  async fnEditMode(deptBO) {
    // if (deptBO.receiptimg) {
    //   this.picurl = "data:image/png;base64," + deptBO.receiptimg;
    // }

    //var buffer = Buffer.from(deptBO.receiptimg);


    //this.strImage = deptBO.receiptimg;

    this.receiptsettingsform.setValue({
      restaurantname: deptBO.restaurantname,
      address1: deptBO.address1,
      address2: deptBO.address2,
      address3: deptBO.address3,
      address4: deptBO.address4,
      address5: deptBO.address5,
      header1: deptBO.header1,
      header2: deptBO.header2,
      header3: deptBO.header3,
      header4: deptBO.header4,
      header5: deptBO.header5,
      receipttitle: deptBO.receipttitle,
      footer1: deptBO.footer1,
      footer2: deptBO.footer2,
      footer3: deptBO.footer3,
      footer4: deptBO.footer4,
      footer5: deptBO.footer5,
      font: deptBO.font,
      fontsize: deptBO.fontsize,
      receiptimg: deptBO.receiptimg,
      enablegstno:deptBO.enablegstno,
      enablefssaino:deptBO.enablefssaino,
      restaurantnamelan: deptBO.restaurantnamelan,
      address1lan: deptBO.address1lan,
      address2lan: deptBO.address2lan,
      address3lan: deptBO.address3lan,
      address4lan: deptBO.address4lan,
      address5lan: deptBO.address5lan,
      inactive: deptBO.inactive,
    });

    this.picurl = deptBO.receiptimg
  }

  convertBlobToBase64(blob: Blob) {
    return Observable.create(observer => {
      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(blob);
      reader.onload = (event: any) => {
       // //console.log('Image in Base64: ', event.target.result);
         observer.next(event.target.result);
        observer.complete();
      };

      reader.onerror = (event: any) => {
       // //console.log("File could not be read: " + event.target.error.code);
        observer.next(event.target.error.code);
        observer.complete();
      };
    });
  }
  
  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }




  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }




  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

  
  //  let blob= new Blob([new Uint8Array(deptBO.receiptimg.data).buffer]);
  //let blob= new Blob([deptBO.receiptimgtxt]);
    ////console.log(blob)

    //let blob= new Blob([deptBO.receiptimgtxt], {type: 'image/png'});
    //this.convertBlobToBase64(blob)

    //this.convertBlobToBase64(blob).subscribe(base64ImageUrl => this.picurl =base64ImageUrl);
      

    // this.http.get('https://avatars0.githubusercontent.com/u/5053266?s=460&v=4', { responseType: 'blob' })
    // .pipe(
    //   switchMap(blob => this.convertBlobToBase64(blob))
    // )
    //   .subscribe(base64ImageUrl => //console.log(base64ImageUrl));
    
    ////console.log(JSON.stringify(deptBO.receiptimg))


    // let blob = new Blob([deptBO.receiptimg.data], {type: 'image/png'});
    // //console.log(blob)
    // this.image = blob;

    //let objectURL = 'data:image/jpeg;base64,' + blob;

    //this.picurl =  this.sanitizer.bypassSecurityTrustUrl(objectURL);

    //let blob = new Blob([deptBO.receiptimg], {type: 'image/png'});
   // this.picurl = URL.createObjectURL(blob);


    //const mediaType = 'application/image';
    //const blob = new Blob([deptBO.receiptimg], { type: mediaType });
    //const unsafeImg = URL.createObjectURL(blob);
    // this.picurl = 'data:image/png;base64,' + deptBO.receiptimg;

    //  var data = [{"image_blob":{"type":"img/jpg","data":[123,125]}}];
    //   var blob1 = new Blob([new Uint8Array(data[0].image_blob.data)]);  
    //   const imageUrl = URL.createObjectURL(blob1);  
    //   //console.log(imageUrl);//blob:http://localhost:8100/c489.etc  


    //const mediaType = 'application/image';
    //    const blob = new Blob([deptBO.receiptimg], { type: mediaType });

    //var spicurl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))

    //const unsafeImg = URL.createObjectURL(blob);
    //this.image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);

    //deptBO.receiptimg = URL.createObjectURL(deptBO.receiptimg);
    // //console.log(spicurl);
    //    this.image = unsafeImg;





}
